import { KeepAwake } from '@capacitor-community/keep-awake';

let activeCount = 0;

export const keepAwake = {
  mounted() {
    KeepAwake.keepAwake();
    activeCount++;
    console.debug(`KeepAwake: Keep Awake activated. ActiveDirectives: ${activeCount}`);
  },

  unmounted() {
    activeCount = Math.max(0, activeCount - 1);

    if (activeCount === 0) {
      KeepAwake.allowSleep();
    }
    console.debug(`KeepAwake: Keep Awake deactivated. ActiveDirectives: ${activeCount}`);
  },
};
